import { UserKeySchema } from "@packages/core";
import { createFileRoute } from "@tanstack/react-router";
import * as v from "valibot";

export const Route = createFileRoute("/_authenticated/facilities/$facilityKey/residents/$userKey")({
  params: {
    parse(params) {
      return v.parse(v.object({ userKey: UserKeySchema() }), params);
    },
  },
});
